import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreatePromotionModal from "../../components/Settings/CreatePromotionModal.vue";
import PromotionList from "../../components/Settings/PromotionList.vue";
import { usePromotion } from "../../composables/usePromotion";


export default /*@__PURE__*/_defineComponent({
  __name: 'PromotionListPage',
  setup(__props) {

const {
  customers,
  searchQuery,
  filteredPromotions,
  stats,
  showModal,
  selectedPromotion,
  form,
  errors,
  loading,
  paginationConfig,
  fetchInitialData,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  generatePromotionCode,
  savePromotion,
  deletePromotion,
  canCreatePromotion,
  canUpdatePromotion,
  canDeletePromotion,
  canSaveCurrentPromotion,
  formatPromotionValue,
  formatPromotionDays,
  formatPromotionWindow,
} = usePromotion();

const toggleDay = (day: string) => {
  const nextDays = form.value.valid_days.includes(day)
    ? form.value.valid_days.filter((value) => value !== day)
    : [...form.value.valid_days, day];

  updateField("valid_days", nextDays);
};

onMounted(fetchInitialData);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbMenu, { pageTitle: "promotion_page.list_title" }),
      _createVNode(PromotionList, {
        promotions: _unref(filteredPromotions),
        stats: _unref(stats),
        loading: _unref(loading),
        "search-query": _unref(searchQuery),
        "pagination-config": _unref(paginationConfig),
        "can-create": _unref(canCreatePromotion),
        "can-update": _unref(canUpdatePromotion),
        "can-delete": _unref(canDeletePromotion),
        "format-promotion-value": _unref(formatPromotionValue),
        "format-promotion-days": _unref(formatPromotionDays),
        "format-promotion-window": _unref(formatPromotionWindow),
        "onUpdate:searchQuery": _cache[0] || (_cache[0] = ($event: any) => (searchQuery.value = $event)),
        onCreate: _unref(openCreateModal),
        onEdit: _unref(openEditModal),
        onDelete: _unref(deletePromotion)
      }, null, 8, ["promotions", "stats", "loading", "search-query", "pagination-config", "can-create", "can-update", "can-delete", "format-promotion-value", "format-promotion-days", "format-promotion-window", "onCreate", "onEdit", "onDelete"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(MainFooter),
      _createVNode(CreatePromotionModal, {
        open: _unref(showModal),
        "is-edit": !!_unref(selectedPromotion),
        form: _unref(form),
        customers: _unref(customers),
        errors: _unref(errors),
        loading: _unref(loading),
        "can-create": _unref(canCreatePromotion),
        "can-update": _unref(canUpdatePromotion),
        "can-save": _unref(canSaveCurrentPromotion),
        onClose: _unref(closeModal),
        onSave: _unref(savePromotion),
        onGenerateCode: _unref(generatePromotionCode),
        onUpdateField: _unref(updateField),
        onToggleDay: toggleDay
      }, null, 8, ["open", "is-edit", "form", "customers", "errors", "loading", "can-create", "can-update", "can-save", "onClose", "onSave", "onGenerateCode", "onUpdateField"])
    ])
  ], 64))
}
}

})